import AssetCover from "../../../../common/features/asset/AssetCover.tsx";
import NthEdition from "../../../../common/features/asset/NthEdition.tsx";
import styles from "./TypeaheadAsset.module.scss";
import { ManageAsset } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import { UnsafeHtml } from "../../../../common/core-ui/UnsafeHtml.tsx";
import { boldSubstring } from "../../../../common/utils/string.ts";
import { MatchType } from "./utils.ts";

export default function TypeaheadAsset({
  asset,
  query,
  matchType,
}: {
  asset: ManageAsset;
  query: string;
  matchType: MatchType;
}) {
  return (
    <>
      <AssetCover
        vbid={asset.vbid}
        width={20}
        width2x={60}
        className={styles.cover}
      />
      <div>
        <UnsafeHtml>{boldSubstring(asset.title, query)}</UnsafeHtml>
        <div className={styles.subtitle}>
          {matchType === MatchType.Author || !asset.edition ? (
            <span>
              <UnsafeHtml>{boldSubstring(asset.author, query)}</UnsafeHtml>
            </span>
          ) : (
            <span>
              <NthEdition asset={asset} />
            </span>
          )}
        </div>
      </div>
    </>
  );
}
